export default __webpack_public_path__ + "static/media/icon_phone.dfebf06c.svg";